
<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top">
          <template v-if="searchShow">
            <el-input
                clearable
                v-model="search.searchKey"
                clas="input_search"
                placeholder="搜索关键字"
                @keyup.enter.native="SearchServiceList"
            ></el-input>
            <el-select
                v-model="search.appInfoId"
                clearable
                filterable
                placeholder="反馈应用"
            >
              <el-option
                  v-for="item in appList"
                  :key="item.appInfoId"
                  :label="item.appName"
                  :value="item.appInfoId"
              ></el-option>
            </el-select>
            <el-select
                v-model="search.channelAccountId"
                clearable
                filterable
                placeholder="反馈渠道"
            >
              <el-option
                  v-for="item in channelList"
                  :key="item.channelAccountId"
                  :label="`${item.channelTypeName}-${item.account}`"
                  :value="item.channelAccountId"
              ></el-option>
            </el-select>
            <div class="block timeblock">
              <el-select
                  v-model="search.timeType"
                  clearable
                  placeholder="选择时间"
                  class="xq_time_select"
              >
                <el-option
                    v-for="item in COMPLIANT_TIMETYPE"
                    :key="parseInt(item.key)"
                    :label="item.name"
                    :value="parseInt(item.key) "
                ></el-option>
              </el-select>
              <el-date-picker
                  v-model="value2"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  class="xq_time_picker"
              >
              </el-date-picker>
            </div>

            <el-button size="medium" type="primary" @click="SearchServiceList"
            >查询</el-button
            >
          </template>

          <el-button v-if="downShow" size="medium" type="primary" @click="upserviceList"
          >下载</el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
            :data="tableData"
            size="medium"
            border
            style="width: 100%"
            row-key="customerServiceId"
            v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="50" >
              <template slot-scope="scope">
                <span>{{
                  (page.pageNo - 1) * page.pageSize + scope.$index + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="fbContent" label="反馈内容" min-width="200" max-width="500"> </el-table-column>
            <el-table-column prop="userAccount" label="用户">
              <template slot-scope="scope">
                <div>{{ scope.row.userAccount || scope.row.userinfo }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="appName" label="应用" min-width="120">
            </el-table-column>
            <el-table-column prop="channelAccount" label="渠道">
              <template slot-scope="scope">
                <div>{{scope.row.channelTypeName?'('+scope.row.channelTypeName+')':''}} {{scope.row.channelName}} </div>
              </template>
            </el-table-column>
            <el-table-column prop="fbName" label="类型"></el-table-column>
            <el-table-column prop="hl" label="语言"  width="70">
            </el-table-column>
            <el-table-column prop="appExamId" label="编号">
              <template slot-scope="scope">
                <div>{{ scope.row.examId }}-{{ scope.row.appExamId }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ctime"
              label="反馈时间"
              min-width="140"
            ></el-table-column>
          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNo"
            :page-sizes="[PAGE_SIZE, 15, 20, 25]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {COMPLIANT_TIMETYPE, PAGE_SIZE} from "@/config";

import {emptyShow, formatMaxNum, formatMinNum} from "@utils/tools/index";

export default {
  data() {
    return {
      /* 函数 方法 */
      emptyShow,formatMaxNum,formatMinNum,
      /* 字段或数组 */
      PAGE_SIZE,
      COMPLIANT_TIMETYPE,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value2: "", //以上时间选择器

      enumCode: "PUT_WAY",
      treeProps: {
        //测评题 配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
        // value: "parentId",
        children: "examCategoryVos",
        label: "name",
      },
      channelList: [], //渠道类型list
      appList: [], //归属应用appid

      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      tableData: [], //顶顶那列表

      onTime: "",
      offTime: "", //客服开始和结束时间
      loading: false,

      search: {},

      searchShow: false,
      downShow: false,
      detailShow: false,

    };
  },
  created() {
    this.getChannelList();
    this.getAppList();
    this.getserviceList();
    this.getPermissionButtonList()
  },
  watch: {},
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'taotan:complaint:query') {
            this.searchShow = true
          }
          if (item.code == 'taotan:complaint:down') {
            this.downShow = true
          }
          if (item.code == "taotan:complaint:detail") {
            this.detailShow = true
          }
        })
      }
    },
    // 下载事件
    async upserviceList() {
      if (this.value2 && this.value2.length) {
        if (this.search.timeType == undefined || this.search.timeType=='') {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }
        this.search.startTime = this.value2[0];
        this.search.endTime = this.value2[1];
      }
      if (this.search.timeType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }
      let obj = this.search
      let startTime  = obj.startTime ?obj.startTime :''
      let endTime  = obj.endTime ?obj.endTime :''
      if(startTime && endTime){
        const { data: res } = await this.$get(
            `/feedback/export/create`,
            { params: { ...this.search} },
            {
              headers: {
                // isLoading: true,
              },
            }
        );
        this.$message.success(res.data)
      }else {
        this.$message.warning('请选择时间')
      }
    },
    //获取归属应用
    async getAppList() {
      const { data: orgData } = await this.$get(`/app/list?paging=false`);
      this.appList = orgData.data;
    },
    //获取渠道 账号 类型==改
    async getChannelList() {
      const { data: orgData } = await this.$get(`/channel/account/list?paging=false`);
      this.channelList = orgData.data;
    },

     SearchServiceList(){
       this.page.pageNo = 1
       delete this.page['count']
       this.getserviceList()
     },

    //反馈列表
    async getserviceList() {
      if (this.value2 && this.value2.length) {
        if (this.search.timeType == undefined || this.search.timeType == "") {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }
        this.search.startTime = this.value2[0];
        this.search.endTime = this.value2[1];
      }
      if (this.search.timeType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }

      this.loading = true;
      const { data: res } = await this.$get(
        `/feedback/list`,
        { params: { ...this.search, ...this.page } },
        {
          headers: {
            isLoading: true,
          },
        }
      );
      this.loading = false;
      this.tableData = res.data;
      this.page.count = res.page.count;
    },
    //switch状态改变 --接口 修改岗位状态
    handleSwitch(index) {
      this.$put(`/user/info/status/${this.tableData[index].userId}`);
    },
    //订单详情
    async getOrderDetail(row) {
      // this.$router.push({
      //   name: "ORDER_DETAIL",
      //   query: {
      //     id: 3,
      //     title: "反馈列表",
      //   },
      // });
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;
  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    &_Top {
      display: flex;
      gap: 15px;
      .el-input {
        width: auto;
      }
      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }
    &_Container {
      margin-top: 20px;
    }
    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>
